import { computed } from 'vue';
import { propertyBaseRouter } from '@/router/data';
import router from '@/router';
import { ResidentAuthType } from '@/views/pm/old-community/resident-auth/all.type';

// 导航
const breadHeaders = [{ label: WordList.DeliveryStaffAuth }];

// 标签卡数据
const navs = [
    {
        label: WordList.DeliveryRfCard,
        key: 'rfCard',
        path: `/${propertyBaseRouter}/oldStaffAuth?type=rfCard`
    }
];
const initData = (
    type: ResidentAuthType
) => {
    // 激活的标签
    const activeNavItem = computed(() => type);

    // 标签切换操作
    const changePath = (key: string, path: string) => {
        router.push(path);
    };

    return {
        breadHeaders,
        navs,
        activeNavItem,
        changePath
    };
};
export default initData;